import { t } from "@lingui/macro";

import { PageHero, Prose } from "../_components/page-shell";

export const TermsPage = () => {
  return (
    <>
      <PageHero
        eyebrow={t`Legal`}
        title={t`Terms of Use`}
        subtitle={t`The rules for using Izicvs.`}
      />
      <Prose>
        <p>{t`Last updated: these terms may be updated from time to time. Continued use of Izicvs after changes take effect means you accept the revised terms.`}</p>

        <h2>{t`Acceptance of terms`}</h2>
        <p>{t`By accessing or using Izicvs, you agree to be bound by these Terms of Use. If you do not agree, please do not use the service.`}</p>

        <h2>{t`Description of the service`}</h2>
        <p>{t`Izicvs is an AI powered platform, operated by Nextilabs, that helps you build resumes, analyze your documents, and search for jobs. Features may evolve over time as we improve the product.`}</p>

        <h2>{t`Accounts and eligibility`}</h2>
        <p>{t`You must provide accurate information when creating an account and keep your credentials secure. You are responsible for activity that occurs under your account. You must be of legal age to form a binding contract in your jurisdiction to use Izicvs.`}</p>

        <h2>{t`Subscriptions and billing`}</h2>
        <p>{t`Izicvs offers a Free plan as well as paid Pro and Autopilot plans. Paid plans are billed in advance on a recurring basis. You can cancel at any time, and your plan will remain active until the end of the current billing period. Applicable taxes are included in the prices shown.`}</p>

        <h2>{t`Acceptable use`}</h2>
        <p>{t`You agree not to misuse Izicvs, including by attempting to disrupt the service, access it without authorization, submit unlawful or infringing content, or use it in a way that violates the rights of others or applicable laws.`}</p>

        <h2>{t`Intellectual property`}</h2>
        <p>{t`You own the resume content and personal information you provide. Izicvs and Nextilabs own the platform, software, design, and brand. We grant you a limited, non exclusive right to use the service, and you grant us the permissions needed to process your content in order to deliver the features you request.`}</p>

        <h2>{t`Disclaimers`}</h2>
        <p>{t`Izicvs is provided on an as is and as available basis. We do not guarantee employment, interviews, or any specific outcome from using the platform. Results depend on many factors outside our control.`}</p>

        <h2>{t`Limitation of liability`}</h2>
        <p>{t`To the maximum extent permitted by law, Izicvs and Nextilabs are not liable for indirect, incidental, or consequential damages arising from your use of the service. Our total liability is limited to the amount you paid us in the twelve months before the claim.`}</p>

        <h2>{t`Termination`}</h2>
        <p>{t`You may stop using Izicvs and delete your account at any time. We may suspend or terminate access if you violate these terms or if we need to protect the service and its users.`}</p>

        <h2>{t`Changes to the terms`}</h2>
        <p>{t`We may update these Terms of Use as the service and legal requirements evolve. When we make significant changes, we will update this page so you can review the current version.`}</p>

        <h2>{t`Contact`}</h2>
        <p>{t`If you have questions about these terms, please contact us at legal@izicvs.com.`}</p>
      </Prose>
    </>
  );
};
